// --------------------------------------------------------------------------
// priorityNav.js
// --------------------------------------------------------------------------
// Initialises priorty nav plugin
// --------------------------------------------------------------------------

EC.priorityNav = function () {

    'use strict';

    function init () {
        const nav = priorityNav.init({
            mainNavWrapper: '.js-priority-nav',
            navDropdownClassName: 'b-sub-nav__dropdown',
            navDropdownToggleClassName: 'b-sub-nav__dropdown-trigger',
            breakPoint: 640,
            navDropdownBreakpointLabel: 'More in this section'
        });
    }

    return {
        init: init
    };

}();